module.exports = __webpack_public_path__ + "static/media/img.0ab1c9e8.svg";